import { get, post } from '../../../../GlobalModules/Utility/Http';
import { topSellingLowSellingProductsPost } from '../Model/DashboardModel';

const REPORT_BASE_URL = `${process.env.EXTENDED_URL}report`;

// POS Dashboard API functions
export const getDashboardStats = async (startDate, endDate) => {
    const storeId = localStorage.getItem('store_id');
    const response = await get(`${process.env.EXTENDED_URL}/dashboard/get_dashboard_stats?store_id=${storeId}&start_date=${startDate}&end_date=${endDate}`);
    return response.data;
};

export const getOrderChartStats = async (startDate, endDate) => {
    const storeId = localStorage.getItem('store_id');
    const response = await get(`${process.env.EXTENDED_URL}/dashboard/get_order_chart_stats?store_id=${storeId}&start_date=${startDate}&end_date=${endDate}`);
    return response.data;
};

export const getRecentTransactions = async (startDate, endDate) => {
    const storeId = localStorage.getItem('store_id');
    const response = await get(`${process.env.EXTENDED_URL}/dashboard/get_recent_transactions?store_id=${storeId}&start_date=${startDate}&end_date=${endDate}`);
    return response.data;    
};

export const topSellingLowSellingProducts = async (data) => {
    const filters = {
        store_id: data?.store_id,
        start_date: data?.start_date,
        end_date: data?.end_date
    };
    const queryParams = {
        filters: JSON.stringify(filters)
    };
    const response = await get(`${process.env.EXTENDED_URL}report/top_selling_low_selling_products`, queryParams);
    return topSellingLowSellingProductsPost(response);
};

/**
 * Fetch Low Stock Products (Product Alert)
 */
export const getLowStockProducts = async () => {
    try {
        const storeId = localStorage.getItem('store_id');
        const filters = {
            limit: 10,
            offset: 0,
            store_id: storeId,
            sort: [{ colId: "quantity", sort: "asc" }]
        };
        const queryParams = {
            filters: JSON.stringify(filters)
        };
        const res = await get(`${REPORT_BASE_URL}/productalert`, queryParams);
        const data = res.data || {};
        return data.success
            ? { success: true, data: data.data, total: data.total }
            : { success: false, message: data.message || 'Failed to fetch low stock products', data: null };
    } catch (e) {
        console.error('Error fetching low stock products:', e);
        return { success: false, message: 'Error fetching low stock products', data: null };
    }
};

/**
 * Fetch Order Type Wise Statistics
 */
export const getOrderTypeWiseStats = async (startDate, endDate) => {
    try {
        const storeId = localStorage.getItem('store_id');
        const response = await get(`${process.env.EXTENDED_URL}/dashboard/get_order_type_wise_stats?store_id=${storeId}&start_date=${startDate}&end_date=${endDate}`);
        return response.data;
    } catch (e) {
        console.error('Error fetching order type wise statistics:', e);
        return { success: false, message: 'Error fetching order type wise statistics', data: null };
    }
};